<template>
	<div class="Slider">
		<input type="range" :id="id" :min="min" :max="max" :value="value" :step="step" />
	</div>
</template>

<script>
export default {
	components: {},
	name: 'CloSlider',
	data() {
		return {};
	},
	props: {
		id: {
			type: String,
			default: '',
		},
		min: {
			type: String,
			default: '',
		},
		max: {
			type: String,
			default: '',
		},
		value: {
			type: String,
			default: '',
		},
		step: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss">
// Slider styles

.Slider {
	// Lots of input styling to handle cross-browser nuances
	// -----------------------------------------------------
	input[type='range'] {
		/*removes default webkit styles*/
		-webkit-appearance: none;

		/*fix for FF unable to apply focus style bug */
		//border: 1px solid $color-white;

		/*required for proper track sizing in FF*/
		width: 100%;

		/*removes huge padding in IE */
		padding-top: 0rem;
		padding-bottom: 0rem;
	}

	// Webkit ----------------------------
	input[type='range']::-webkit-slider-runnable-track {
		width: 100%;
		height: 5px;
		background: $color-neutral-2;
		border: none;
		border-radius: 3px;
	}
	input[type='range']::-webkit-slider-thumb {
		-webkit-appearance: none;
		border: 1px solid $color-white;
		height: 16px;
		width: 16px;
		border-radius: 50%;
		background: $color-link;
		margin-top: -5px;
	}
	input[type='range']:focus {
		outline: none;
	}
	input[type='range']:focus::-webkit-slider-runnable-track {
		background: $color-neutral-3;
	}

	// Mozilla ----------------------------
	input[type='range']::-moz-range-track {
		width: 100%;
		height: 5px;
		background: $color-neutral-3;
		border: 1px solid $color-white;
		border-radius: 3px;
	}
	input[type='range']::-moz-range-thumb {
		border: 1px solid $color-white;
		height: 16px;
		width: 16px;
		border-radius: 50%;
		background: $color-link;
	}

	/*hide the outline behind the border*/
	input[type='range']:-moz-focusring {
		outline: 1px solid white;
		outline-offset: -1px;
	}

	// Microsoft ----------------------------
	input[type='range']::-ms-track {
		width: 100%;
		height: 5px;

		/*remove bg colour from the track, we'll use ms-fill-lower and ms-fill-upper instead */
		background: transparent;

		/*leave room for the larger thumb to overflow with a transparent border */
		border-color: transparent;
		border-width: 7px 0;

		/*remove default tick marks*/
		color: transparent;
	}
	input[type='range']::-ms-fill-lower {
		background: $color-neutral-3;
		border-radius: 10px;
	}
	input[type='range']::-ms-fill-upper {
		background: $color-neutral-2;
		border-radius: 10px;
	}
	input[type='range']::-ms-thumb {
		border: 1px solid $color-white;
		height: 16px;
		width: 16px;
		border-radius: 50%;
		background: $color-link;
	}
	input[type='range']:focus::-ms-fill-lower {
		background: $color-link;
	}
	input[type='range']:focus::-ms-fill-upper {
		background: $color-neutral-3;
	}
}
</style>
